import VueTelInputVuetify from 'vue-tel-input-vuetify/lib'

export default (Vue, vuetify) => {
  Vue.use(VueTelInputVuetify, {
    vuetify
  })
}
